import {
  GreyGrey50,
  GreyGrey60,
  Primary12SemiBold,
  IconArrowRotateRightLeft,
  Box,
  Flex
} from '@sequencehq/core-components'
import { timelinePhasesAtom } from '../atoms/timeline.atom'
import { useAtom } from 'jotai'
import {
  BILLING_PERIOD_PILL_OFFSET_FROM_DATE_PX,
  TIMELINE_PHASE_ROW_HEIGHT_PX,
  TIMELINE_DATA_SERIES_Z_INDEX,
  TIMELINE_PHASE_MARKERS_Z_INDEX
} from '../timeline.constants'
import { useTimelineDimensions } from '../hooks/useTimelineDimensions'

const PhaseMarker = (props: { offset: number }) => {
  return (
    <Box
      position="absolute"
      left={`${props.offset}px`}
      borderLeft={`1px dashed ${GreyGrey50}`}
      height="100%"
      top={0}
      zIndex={TIMELINE_PHASE_MARKERS_Z_INDEX}
    ></Box>
  )
}

const PhaseLabel = (props: {
  offset: number
  name: string
  resetsBilling?: boolean
  width?: string
}) => {
  return (
    <>
      <Flex
        position="absolute"
        top="8px"
        left={`${props.offset + BILLING_PERIOD_PILL_OFFSET_FROM_DATE_PX}px`}
        {...Primary12SemiBold}
        color={GreyGrey60}
        gap="4px"
        width={props.width ?? '100%'}
        whiteSpace="nowrap"
        overflow="hidden"
      >
        {props.name}
        {props.resetsBilling && <IconArrowRotateRightLeft color={GreyGrey60} />}
      </Flex>
    </>
  )
}

export const ScheduleTimelinePhases = () => {
  const [timelinePhases] = useAtom(timelinePhasesAtom)
  const { timelineWidth } = useTimelineDimensions()

  return (
    <>
      {timelinePhases.map(phase => (
        <PhaseMarker offset={phase.startDate.offset} key={phase.id} />
      ))}
      <Box
        position="relative"
        height={`${TIMELINE_PHASE_ROW_HEIGHT_PX}px`}
        width={`${timelineWidth}px`}
        overflow="hidden"
        data-testid="timeline.phases"
        zIndex={TIMELINE_DATA_SERIES_Z_INDEX}
        pointerEvents="none"
      >
        {timelinePhases.map((phase, idx) => {
          /**
           * We set a maximum width for the label to prevent short phases having
           * overlapping labels.
           */
          const startOfNextPhase = timelinePhases[idx + 1]?.startDate?.offset
          return (
            <PhaseLabel
              key={phase.id}
              offset={phase.startDate.offset}
              width={
                startOfNextPhase
                  ? `${startOfNextPhase - 8 - phase.startDate.offset}px`
                  : undefined
              }
              name={phase.name}
              resetsBilling={phase.resetsBilling}
            />
          )
        })}
      </Box>
    </>
  )
}
